"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RolloutsEntity_1 = __importDefault(require("./Entity/RolloutsEntity"));
var RolloutsApi = /** @class */ (function () {
    function RolloutsApi(session) {
        this.rolloutsEntity = new RolloutsEntity_1.default(session);
    }
    RolloutsApi.prototype.getAll = function () {
        return this.rolloutsEntity.getAll();
    };
    RolloutsApi.prototype.createOrUpdateUserRollout = function (params) {
        return this.rolloutsEntity.createOrUpdateUserRollout(params);
    };
    return RolloutsApi;
}());
exports.default = RolloutsApi;
//# sourceMappingURL=RolloutsApi.js.map